import React, {useEffect, useState} from 'react';
import './configuration.vendor.container.sass';
import { Stepper } from '../components/stepper/stepper';
import { ProfileForm } from '../components/profile-form/profile-form';
import { FinancesForm } from '../components/finances-form/finances-form';
import { InviteForm } from '../components/invite-form/invite-form';
import { Header } from '../components/header/header';
import { Footer } from '../../landing-page/vendor/components/footer/footer';
import { getSession } from '../../login/session.slice';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { useHistory } from 'react-router-dom';
import { Config } from '../../../config/config';

export const ConfigurationVendorContainer = () => {

    const [isLoaded, setIsLoaded] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        dispatch(getSession({}))
            .then(unwrapResult)
            .then(data => {
                if(data?.teams?.[0]?.vendor?.name) {
                    history.push(Config.routePaths.main.vendor.dashboard.profile.path);
                }
                setIsLoaded(true);
            });
    }, []);

    return isLoaded ? (
        <div className='vv-vendor-configuration-container'>
            <Header/>
            <Stepper>
                <ProfileForm/>
                <FinancesForm/>
                <InviteForm/>
            </Stepper>
            <Footer/>
        </div>
    ) : null;
};
